// extracted by mini-css-extract-plugin
module.exports = {"header":"SizesBottomSheet_header__mFKzY"};